import { d } from './chunk-6EFRS222.mjs';
import { b } from './chunk-26IU2X5T.mjs';
import a from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var p=a.a`
  display: inline-flex;
  align-items: baseline;
  cursor: pointer;
  color: ${({$colorToken:r})=>`var(--${r})`};
  font-weight: var(--font-weight-bold);
  text-decoration: none;
  gap: ${({$icon:r,$inline:o})=>r&&(o?"var(--spacing-x-small)":"var(--spacing-small)")};

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    border-radius: var(--border-radius-small);
    outline-offset: 1px;
    outline-color: var(--border-link-focus);
    outline-width: var(--border-width-small);
  }

  &:active > span {
    color: ${({$activeColorToken:r})=>`var(--${r})`};
  }
`,s=a.span``;var m=({children:r,icon:o,inline:d$1=!1,size:i="regular",colorToken:n="foreground-link",activeColorToken:f="foreground-link-active",...c})=>jsxs(p,{rel:o?"noopener noreferrer":void 0,target:o?"_blank":void 0,$icon:o,$inline:d$1,$colorToken:n,$activeColorToken:f,...c,children:[jsx(d,{forwardedAs:"span",weight:"bold",size:i,colorToken:n,children:r}),o&&jsx(s,{children:jsx(b,{size:i,icon:o})})]});m.displayName="Link";var k=a(m)``;

export { k as a };
